import React from 'react';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { AccordionContentStyled, LabelStyled } from './AccordionItemStyled';
export function AccordionItem({ title, children, isOpen, onClick }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(LabelStyled, { onClick: onClick },
            React.createElement(RegularTextLevel4, null, title)),
        isOpen && React.createElement(AccordionContentStyled, null, children)));
}
